// ALTO RENDIMIENTO

import {
  createContext,
  useContext,
  useState,
  useEffect,
} from "react"

type PerformanceContextType = {
  highPerformance: boolean
  toggleHighPerformance: () => void
}

const PerformanceContext = createContext<PerformanceContextType | null>(null)

export function PerformanceProvider({
  children,
}: {
  children: React.ReactNode
}) {
  // Cargar desde localStorage al iniciar
const [highPerformance, setHighPerformance] = useState<boolean>(() => {
  const saved = localStorage.getItem("highPerformance")
  return saved ? JSON.parse(saved) : true
})

  // Guardar cada vez que cambie
  useEffect(() => {
    localStorage.setItem(
      "highPerformance",
      JSON.stringify(highPerformance)
    )
  }, [highPerformance])

  const toggleHighPerformance = () => {
    setHighPerformance((prev) => !prev)
  }

  return (
    <PerformanceContext.Provider
      value={{
        highPerformance,
        toggleHighPerformance,
      }}
    >
      {children}
    </PerformanceContext.Provider>
  )
}

export function usePerformance() {
  const ctx = useContext(PerformanceContext)

  if (!ctx) {
    throw new Error("usePerformance debe usarse dentro de PerformanceProvider")
  }

  return ctx
}


/* // FUNCIONES DE ALO RENIMIENTO

"use client"

import { createContext, useContext, useState } from "react"

type PerformanceContextType = {
  highPerformance: boolean
  toggleHighPerformance: () => void
}

const PerformanceContext = createContext<PerformanceContextType | null>(null)

export function PerformanceProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [highPerformance, setHighPerformance] = useState(true)

  return (
    <PerformanceContext.Provider
      value={{
        highPerformance,
        toggleHighPerformance: () =>
          setHighPerformance(v => !v),
      }}
    >
      {children}
    </PerformanceContext.Provider>
  )
}

export function usePerformance() {
  const ctx = useContext(PerformanceContext)

  if (!ctx) {
    throw new Error("usePerformance debe usarse dentro de PerformanceProvider")
  }

  return ctx
} */